import { useTranslation } from "react-i18next";
import { useGlobalData } from "../../../../../../contexts/GlobalDataProvider";
import { fieldTypes } from "../../../../../../utils/config/widgetsConfig";


// TODO: find a better place to store this constant
const REPORTING_METHOD = "UnifiedSynergy";

const useCreateIncidentRecord = ({ selectedPOI, mapClickCoordinates, genericItemsData, incidentPropertiesTypes
}) => {
    const { t } = useTranslation();
    const { cityService, setCityService, incidentCategoriesData, isFetchingIncidentCategories,
        incidentPropertiesData, isFetchingIncidentProperties, isFetchingGenericItems
    } = useGlobalData();

    /**
     * Serializes an array of generic items into a new array of objects with 'value' and 'label' properties.
     * @param {Array} genericItems - The array of generic items to be serialized.
     * @returns {Array} - The serialized array of objects with 'value' and 'label' properties.
     */
    const serializeGenericItems = (genericItems) => {
        if (!genericItems) return [];

        return genericItems.map(item => {
            return {
                value: item.id,
                label: item.name,
                data: item
            }
        });
    }

    /**
    * Retrieves options data from incident properties.
    *
    * @param {object} incidentPropertiesData - The incident properties data.
    * @param {string} type - The type of incident properties data to retrieve.
    * @returns {array} - The sorted options data.
    */
    const getOptionsDataFromIncidentProperties = (incidentPropertiesData, type) => {
        if (!incidentPropertiesData) return [];

        return incidentPropertiesData[type]?.sort((a, b) => {
            const aNum = !isNaN(a.value) ? Number(a.value) : Infinity;
            const bNum = !isNaN(b.value) ? Number(b.value) : Infinity;
            return aNum - bNum;
        }) || [];
    };

    return [
        {
            key: 'reportingMethod',
            name: t('input.reporting_method'),
            fieldTypeOf: fieldTypes.singleSelect,
            value: REPORTING_METHOD,
            isVisible: false
        },
        {
            key: 'title',
            name: t('input.title'),
            fieldTypeOf: fieldTypes.textBox,
            size: 24,
            required: true
        },
        {
            key: 'description',
            name: t('input.description'),
            fieldTypeOf: fieldTypes.textBox,
            size: 24,
            required: true,
        },
        {
            key: 'cityService',
            name: t('input.city_service'),
            fieldTypeOf: selectedPOI ? fieldTypes.textBox : fieldTypes.singleSelect,
            size: 24,
            value: selectedPOI ? selectedPOI.name : null,
            options: serializeGenericItems(genericItemsData),
            disabled: !!selectedPOI,
            loading: isFetchingGenericItems,
            required: true,
            onChange: (value, option) => {
                setCityService(option?.data);
            }
        },
        {
            key: 'category',
            name: t('Category'),
            fieldTypeOf: fieldTypes.singleSelect,
            size: 12,
            options: incidentCategoriesData,
            loading: isFetchingIncidentCategories,
            showSearch: true,
            required: true,
            disabled: isFetchingIncidentCategories || !cityService,
            description: t('tooltip.incident_category_description')
        },
        {
            key: 'urgency',
            name: t('input.urgency'),
            fieldTypeOf: fieldTypes.singleSelect,
            required: true,
            size: 12,
            options: getOptionsDataFromIncidentProperties(incidentPropertiesData, incidentPropertiesTypes.urgencies),
            loading: isFetchingIncidentProperties,
        },
        {
            key: 'impact',
            name: t('input.impact'),
            fieldTypeOf: fieldTypes.singleSelect,
            required: true,
            size: 12,
            loading: isFetchingIncidentProperties,
            isVisible: false,
            value: getOptionsDataFromIncidentProperties(incidentPropertiesData, incidentPropertiesTypes.impacts)?.[0]?.value
        },
        {
            key: 'latitude',
            name: t('input.latitude'),
            fieldTypeOf: fieldTypes.number,
            size: 12,
            value: mapClickCoordinates?.lat,
            disabled: true
        },
        {
            key: 'longitude',
            name: t('input.longitude'),
            fieldTypeOf: fieldTypes.number,
            size: 12,
            value: mapClickCoordinates?.lng,
            disabled: true
        }
    ]

}

export default useCreateIncidentRecord;
